/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ n: NonNullable<unknown>, count: NonNullable<unknown> }} Wrapped_Card_OfInputs */

const en_us2_wrapped_card_of = /** @type {(inputs: Wrapped_Card_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Card ${i?.n} of ${i?.count}`)
};

const pt_br2_wrapped_card_of = /** @type {(inputs: Wrapped_Card_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Cartão ${i?.n} de ${i?.count}`)
};

const es_419_wrapped_card_of = /** @type {(inputs: Wrapped_Card_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tarjeta ${i?.n} de ${i?.count}`)
};

const pt_pt2_wrapped_card_of = /** @type {(inputs: Wrapped_Card_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Cartão ${i?.n} de ${i?.count}`)
};

const fr_fr2_wrapped_card_of = /** @type {(inputs: Wrapped_Card_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Carte ${i?.n} sur ${i?.count}`)
};

const de_de2_wrapped_card_of = /** @type {(inputs: Wrapped_Card_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Karte ${i?.n} von ${i?.count}`)
};

const it_it2_wrapped_card_of = /** @type {(inputs: Wrapped_Card_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Scheda ${i?.n} di ${i?.count}`)
};

/**
* | output |
* | --- |
* | "Card {n} of {count}" |
*
* @param {Wrapped_Card_OfInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const wrapped_card_of = /** @type {((inputs: Wrapped_Card_OfInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wrapped_Card_OfInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_wrapped_card_of(inputs)
	if (locale === "es-419") return es_419_wrapped_card_of(inputs)
	if (locale === "pt-PT") return pt_pt2_wrapped_card_of(inputs)
	if (locale === "fr-FR") return fr_fr2_wrapped_card_of(inputs)
	if (locale === "de-DE") return de_de2_wrapped_card_of(inputs)
	if (locale === "it-IT") return it_it2_wrapped_card_of(inputs)
	return en_us2_wrapped_card_of(inputs)
});
export { wrapped_card_of as "wrapped.card_of" }